/**
 * Стиль фоновой картинки, безопасный к отсутствующему адресу.
 *
 * В шаблонах фон собирался строкой: `url('${item.image}')`. Когда картинки
 * у сущности нет, в строку подставлялось null или undefined, и браузер
 * послушно шёл за адресом `/null` — 404 на каждый показ страницы, плюс
 * лишний запрос в очереди перед контентом.
 *
 * Здесь пустое значение означает «фона нет»: свойство просто не выводится.
 */
export function backgroundImageStyle(url) {
    if (!url || typeof url !== 'string') {
        return {};
    }

    const trimmed = url.trim();

    // 'null' и 'undefined' строками приходят из API так же буднично,
    // как настоящие адреса.
    if (trimmed === '' || trimmed === 'null' || trimmed === 'undefined') {
        return {};
    }

    return {backgroundImage: `url('${trimmed.replace(/'/g, "\\'")}')`};
}
